<template>
  <artmisads-modal
    :open="true"
    title="Payment Details"
    :width="1200"
    :onCancel="() => props.setShowPaymentDetailModal(false)"
    :destroyOnClose="true"
    :maskClosable="false"

    :footer="null"
  >
    <a-spin :spinning="spinning">
      <div class="payment">
        <div class="detail">
          <p>Details</p>
          <div class="filter">
            <div class="button-groups">
              <buttonGroups
                :pagination="{
                  total: listTotal,
                  current: params.page,
                  size: params.size,
                }"
                :tableData="list"
                @pageChange="onPageChange"
              />
               <artmisads-segmented-tabs
                   v-model="activeTab"
                   :items="programConfig"
                   :disabled="spinning"
                   @change="onChangeTab"
                />
            </div>
            <div class="search">
              <artmisads-button-special @click="financePulisherBillingsDetailsBillingIdItemsExport">
                <svg class="icon daochu" aria-hidden="true">
                  <use xlink:href="#icon-daochu"></use>
                </svg>
                <span class="btn-text">Export</span>
              </artmisads-button-special>
              <artmisads-select
                show-search
                v-model:value="params.brandId"
                style="width: 232px"
                :options="brandOptions"
                @search="searchBrand"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                placeholder="All"
                allowClear
                @change="onChangeBrand"
              />
            </div>
          </div>
          <div class="table">
            <artmisads-table
              :columns="columns"
              row-key="id"
              :data-source="list"
              :pagination="{
                total: listTotal,
                current: params.page,
                pageSize: params.size,
                showSizeChanger: true
              }"
              :change="onChangePage"
              tableLayout="fixed"
            >
              <template #bodyCell="{ column, record, text }">
                <template v-if="column.name === 'showCurrency'">
                  {{CURRENCY_DATA_MAPPER[record.currency]}}{{text}}
                </template>
                <template v-if="column.name === 'status' || column.name === 'paymentStatus'">
                  <financeStatus :type="text"/>
                </template>
                <template v-if="column.name === 'action'">
                  <artmisads-select-button
                    v-if="record.paymentStatus === 'paid'"
                    size="small"
                    @click="() => handleSetToNotPaid(record)"
                  >
                    SetToNotPaid
                  </artmisads-select-button>
                </template>
              </template>
            </artmisads-table>
          </div>
        </div>
      </div>
    </a-spin>
  </artmisads-modal>
</template>

<script setup>
import { useRouter } from "vue-router";
import moment from 'moment';
import { keyBy } from 'lodash';
import { AMAZON_CURRENCY_MAPPER, AMAZON_COUNTRY_TIME_TZ } from '~/contants/common';
import { ref, onBeforeMount, computed } from "vue";
import { Modal, message } from 'ant-design-vue';
import { financeApi } from "~/server/operator/finance";
import { COUNTRY_BASE, CURRENCY_DATA_MAPPER } from "~/contants/common";
import ButtonGroups from '~/pages/seller/Brands/components/buttonGroups.vue';
import financeStatus from '~/components/financeStatus';
import { publisherAdminApi } from '~/server/index'
import { useSystemStore } from '@/storeData/system';
const systemStore = useSystemStore();
const activeTab=ref('0')
const programConfig = computed(() => systemStore.programConfig);
const COUNTRY_BASE_MAP = keyBy(COUNTRY_BASE, 'host');
const router = useRouter();
const props = defineProps([ 'setShowPaymentDetailModal', 'billingId', 'marketplace']);
const list = ref([]);
const listTotal = ref(0);
const spinning = ref(false);
const billingBusinessSourceData = ref([
  'amazon_attribution',
  'amazon_associate',
  'amazon_creator_connection',
])
const brandOptions = ref([]);
const params = ref({
  page: 1,
  size: 10,
  keyword: null,
});

const baseColumns = [
  {
    title: 'Brand',
    dataIndex: 'brandName',
    width: 120,
  },
  {
    title: 'Sales',
    dataIndex: 'saleCommissionAmount',
    width: 120,
    name: 'showCurrency',
  },
  {
    title: 'Commissions',
    dataIndex: 'commissionAmount',
    width: 120,
    name: 'showCurrency',
  },
  {
    title: 'Brand Payment Status',
    dataIndex: 'status',
    width: 150,
    name: 'status',
  },
];

const attributionColumns = [
  {
    title: 'Artemis Ads Payment Status',
    dataIndex: 'paymentStatus',
    width: 150,
    name: 'paymentStatus',
  },
  {
    title: 'Action',
    dataIndex: 'action',
    width: 140,
    name: 'action',
    fixed: 'right',
  },
];

const columns = computed(() => {
  if (activeTab.value === '0') {
    return [...baseColumns, ...attributionColumns];
  }
  return baseColumns;
});
const onChangeTab=(tab)=>{
  params.value.page = 1;
  params.value.size = 10;
  getFinancePulisherBillingsDetailsBillingIdItems()
}
const onChangePage = (data, filters) => {
  const { current, pageSize } = data;
  params.value.page = current;
  params.value.size = pageSize;
  getFinancePulisherBillingsDetailsBillingIdItems();
}

const getFinancePulisherBillingsDetailsBillingIdItems = async () => {
  spinning.value = true;
  const keyword = brandOptions.value.find(i => params.value.brandId === i.id)?.amazonBrandName;
  const paramsData = { ...params.value, billingId: props.billingId, keyword,billingBusinessSource:billingBusinessSourceData.value[activeTab.value] };
  delete paramsData.brandId;
  const res = await financeApi.getFinancePulisherBillingsDetailsBillingIdItems(paramsData);
  const { data, total } = res;
  if (res) {
    listTotal.value = total;
    list.value = data;
  }
  spinning.value = false;
};

const searchBrand = async keyword => {
  const params = {
    keyword,
    marketplace: props.marketplace
  };
  let data = await publisherAdminApi.searchBrand(params);
  if (data && data.length) {
    data = data.map(item => {
      item.value = item.id;
      item.label = item.amazonBrandName;
      return item;
    })
    brandOptions.value = data;
  }
}

const onChangeBrand = () => {
  params.value.page = 1;
  getFinancePulisherBillingsDetailsBillingIdItems();
}

const onPageChange = current => {
    params.value.page =  current;
    getFinancePulisherBillingsDetailsBillingIdItems();
  }

const financePulisherBillingsDetailsBillingIdItemsExport = () => {
  const finalParams = {
    qs: {
      billingId: props.billingId,
      billingBusinessSource: billingBusinessSourceData.value[activeTab.value],
    },
    fileName: `payment-detail-${moment().format('YYYY-MM-DD')}.csv`,
    platform: 'operator'
  }
  financeApi.financePulisherBillingsDetailsBillingIdItemsExport(finalParams);
}

const handleSetToNotPaid = (record) => {
  Modal.confirm({
    title: 'Notice',
    content: 'Are you sure to change ArtemisAdsPaymentStatus of this brand to Not Paid?',
    onOk: async () => {
      spinning.value = true;
      const res = await financeApi.financePublisherBillingsDetailsPaymentBrandsSetToNotPaid({
        billingId: props.billingId,
        brandId: record.brandId ?? record.id,
      });
      if (res?.data === null) {
        message.success('Success');
        await getFinancePulisherBillingsDetailsBillingIdItems();
      }
      spinning.value = false;
    },
  });
};

onBeforeMount(() => {
  getFinancePulisherBillingsDetailsBillingIdItems();
});
</script>

<style lang="less" scoped>
.payment {
  .info {
    margin-top: 6px;
    .head {
      display: flex;
      justify-content: space-between;
      > p {
        font-weight: 600;
        font-size: 20px;
        color: var(--dark-1);
        letter-spacing: 0.5px;
        line-height: 28px;
      }
    }
  }
 
  .detail {
    > p {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;
      margin-top: 16px;
      margin-bottom: 16px;
    }
    .filter {
      display: flex;
      justify-content: space-between;
       .button-groups{
        display: flex;
      }
      .search {
        display: flex;
        > button {
          display: flex;
          margin-right: 16px;
          .daochu {
            width: 20px;
            height: 20px;
            margin-right: 8px;
            fill: var(--dark-1);
          }
          > svg {
            align-self: center;
          }
          > span {
            align-self: center;
          }
        }
      }
    }
    .table {
      margin-top: 16px;
    }
  }
  
}
</style>
